export const layers = {
  municipalityMask: {
    'id': 'statistical-sector-municipality-mask',
    'type': 'fill',
    'source': 'gemeente',
    'source-layer': 'Gemeente',
    'minzoom': 10,
    'maxzoom': 16,
    'filter': ['!=', ['get', 'ID_gemeente'], -1],
    'paint': {
      'fill-color': '#217F9A',
      'fill-opacity': 0.2,
    },
  },
  selectedStatisticalSector: {
    'id': 'selected-statistical-sector-border',
    'type': 'line',
    'source': 'stat-sector',
    'source-layer': 'Stat_sector',
    'minzoom': 10,
    'maxzoom': 16,
    'filter': ['==', ['get', 'ID_stat_sect'], -1],
    'paint': {
      'line-color': '#21697F',
      'line-width': 2,
    },
  },
};
